import {Component, EventEmitter, inject, OnInit, Output} from '@angular/core';
import {select, Store} from "@ngrx/store";
import {AppState} from "../../../../../../store/reducers";
import {map, Observable} from "rxjs";
import {selectStoreItems} from "../../../../../../store/entities/store-item/store-item.selectors";
import {StoreItemEntity} from "../../../../../../store/entities/store-item/store-item.model";
import {
  FrequentlyAskedQuestion
} from "../../../../../../store/entities/frequently-asked-question/frequently-asked-question.model";

@Component({
  selector: 'app-faq-tgsd',
  templateUrl: './faq-tgsd.component.html',
  styleUrl: './faq-tgsd.component.scss'
})
export class FaqTgsdComponent implements OnInit {
  questionsList: FrequentlyAskedQuestion[];

  activeKey = 0;

  @Output() exitHover = new EventEmitter();
  store = inject(Store<AppState>);
  faqs$: Observable<FrequentlyAskedQuestion[]>

  getActiveDescription() {
    if (!this.questionsList?.length) return;
    return this.questionsList[this.activeKey]?.questionAnswer;
  }

  ngOnInit() {

    this.faqs$ = this.store.pipe(select(selectStoreItems(StoreItemEntity.faqs))).pipe(map(z => {
      this.questionsList= z?.slice(0, 5);
      return this.questionsList;
    }))
  }
}
